import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetTemplateData } from "ReduxStore/Slices/templateSlice";
import { resetCampaignData } from "ReduxStore/Slices/campaignSlice";
import { setUserFlow } from "ReduxStore/Slices/userSlice";
import { resetWorkflowState } from "ReduxStore/Slices/workflowSlice";
import { resetAllCampaignData } from "ReduxStore/Slices/allCampaignSlice";
import {
  resetAudieceFilters,
  audienceGetNewFilterData,
} from "ReduxStore/Slices/audienceSlice";
import { useSelector } from 'react-redux';

export default function SidebarNavLink(props) {
  const [hover, setHover] = useState(false);
  const dispatch = useDispatch();
  const { role } = useSelector(
    (state) => state.userSetter
  );
  return (
    <>
      {props.menuName !== "Dashboard" ? (
        <li>
          <NavLink
            tabIndex="-1"
            activeClassName="open"
            className="nav-link dropdown-toggle has_left_icon"
            to={props.menuURL}
            id="dropdown02"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            onMouseOver={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            <span className="menu_icon">
              <span className="svg_outer">
                {hover ? (
                  <span
                    className={props.menuIcon}
                    style={{
                      color: "#2C40CE",
                      transition: "0.3s ease-in-out",
                    }}
                  ></span>
                ) : (
                  <span className={props.menuIcon}></span>
                )}
              </span>
            </span>
            {props.menuName}
          </NavLink>

          <ul
            className={
              props.activeRoute(props.menuURL)
                ? " show dropdown-menu  "
                : "dropdown-menu"
            }
            aria-labelledby="dropdown02"
          >
            {props.menuItems.map((menuItem) => {
              if (menuItem.allow) {
                return (
                  <li>
                    <NavLink
                      tabIndex="-1"
                      activeClassName="active"
                      className={`dropdown-item`}
                      to={menuItem.url}
                      onClick={() => {
                        if (menuItem.url === "/admin/campaign/create") {
                          dispatch(resetCampaignData());
                          dispatch(resetTemplateData());
                          dispatch(setUserFlow("createCampaign"));
                        } else if (menuItem.url === "/admin/campaign/all") {
                          dispatch(resetCampaignData());
                          dispatch(resetTemplateData());
                          dispatch(setUserFlow("createCampaign"));
                          dispatch(resetAllCampaignData());

                        } else if (menuItem.url === "/admin/templates/content") {
                          dispatch(resetTemplateData(role =='publisher'?'blogTab': null));
                          dispatch(resetCampaignData());
                          dispatch(setUserFlow("createTemplate"));
                        }
                        else if (menuItem.url === "/admin/templates/info") {
                          dispatch(resetTemplateData(role =='publisher'?'blogTab': null));
                          dispatch(resetCampaignData());
                          dispatch(setUserFlow("createTemplate"));
                        } else if (
                          menuItem.url === "/admin/workflow/createAutomation"
                        ) {
                          dispatch(resetWorkflowState());
                        } else if (menuItem.url === "/admin/contact/audience/create") {
                          dispatch(resetAudieceFilters());
                          dispatch(audienceGetNewFilterData());
                        }
                        else if (menuItem.url === "/admin/triggersAndEvents/createTrigger") {
                          sessionStorage.removeItem('on_edit_trigger');
                          sessionStorage.removeItem('trigger_edit_');

                        }
                      }}
                    >
                      {menuItem.name}
                    </NavLink>
                  </li>
                );
              }
            })}
          </ul>
        </li>
      ) : (
        <li>
          <NavLink
            tabIndex="-1"
            activeClassName="open"
            className="nav-link dropdown-toggle has_left_icon"
            to={props.menuURL}
            aria-haspopup="true"
            onMouseOver={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            <span className="menu_icon">
              <span className="svg_outer">
                {hover ? (
                  <span
                    className={props.menuIcon}
                    style={{
                      color: "#2C40CE",
                      transition: "0.3s ease-in-out",
                    }}
                  ></span>
                ) : (
                  <span className={props.menuIcon}></span>
                )}
              </span>
            </span>
            {props.menuName}
          </NavLink>
        </li>
      )}
    </>
  );
}
